import { TGetImportsQuery } from '../helpers';
import { IGetImportsListDTO } from '@/models/productsImport.model';

class GetImportsListDTO implements IGetImportsListDTO {
  partner_ids?: string[];
  limit?: number;
  page?: number;

  constructor({ partner_ids, page, limit }: TGetImportsQuery) {
    this.partner_ids = partner_ids;
    this.page = page ?? 1;
    this.limit = limit ?? 10;
  }
}

export default GetImportsListDTO;
